/** @graphql cc **/

import gql from 'graphql-tag';

export const UnifiedUserQuery = gql`
	query UnifiedUserQuery {
		isSiteAdmin
		hasUserAccessAdminRole
		userCanCreateContent
		isNewUser
		currentConfluenceUser {
			isAnonymous
		}
		user: confluence_atlassianUser(current: true) {
			id
			displayName
			photos {
				value
				isPrimary
			}
			emails {
				value
				isPrimary
			}
			confluence {
				permissionType
				space {
					id
				}
				operations {
					operation
					targetType
				}
			}
		}
	}
`;
